// extracted by mini-css-extract-plugin
module.exports = {"pageContentWrapper":"Authenticated_pageContentWrapper__nPMkZ","appContainer":"Authenticated_appContainer__1eocX","lessPadding":"Authenticated_lessPadding__2DiPR"};